import React from "react";
import {Grid, Icon, ListItem} from "@material-ui/core";
import styled from "styled-components";
import Firebase from "firebase";
import SocialMediaItem from "../../Models/SocialMediaItem";
import openWebPage from "../../../../Common/Helper/openWebPage";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import SocialMediaListItem from "./SocialMediaListItem";

const Container = styled(ListItem)`
  padding-top: 30px;
  padding-bottom: 30px;
`;

const StyledFacebookIcon = styled(FacebookIcon)`
  font-size: 35px;
`;
const StyledTwitterIcon = styled(TwitterIcon)`
  font-size: 35px;
`;
const StyledInstagramIcon = styled(InstagramIcon)`
  font-size: 35px;
`;
const StyledYouTubeIcon = styled(YouTubeIcon)`
  font-size: 35px;
`;
const StyledLinkedInIcon = styled(LinkedInIcon)`
  font-size: 35px;
`;

const SocialMediaPageController = () => {
    const socialMediaItems: SocialMediaItem[] = [
        {
            title: 'Facebook',
            icon: <StyledFacebookIcon />,
            url: 'https://www.facebook.com/ManhattanCollegeEdu',
            urlScheme: 'fb://page/?id=211461328925864',
            color: '#1877f2'
        },
        {
            title: 'Twitter',
            icon: <StyledTwitterIcon />,
            url: 'https://twitter.com/ManhattanEdu',
            urlScheme: 'twitter://user?screen_name=ManhattanEdu',
            color: '#1da1f2'
        },
        {
            title: 'Instagram',
            icon: <StyledInstagramIcon />,
            url: 'https://www.instagram.com/manhattanedu/',
            urlScheme: 'instagram://user?username=manhattanedu',
            color: '#c32aa3'
        },
        {
            title: 'YouTube',
            icon: <StyledYouTubeIcon />,
            url: 'https://www.youtube.com/user/manhattancollege',
            urlScheme: 'youtube://www.youtube.com/user/manhattancollege',
            color: '#ff0000'
        },
        {
            title: 'LinkedIn',
            icon: <StyledLinkedInIcon/>,
            url: 'https://www.linkedin.com/school/manhattan-college/',
            urlScheme: 'linkedin://school/manhattan-college/',
            color: '#007bb5'
        },
    ];

    const onClick = (socialMediaItem: SocialMediaItem) => {
        switch(socialMediaItem.title) {
            case 'Facebook':
                Firebase.analytics().logEvent('Social Media', { page_location:  'Dashboard/Facebook',page_title: 'Facebook'});
                break;
            case 'Twitter':
                Firebase.analytics().logEvent('Social Media', { page_location:  'Dashboard/Twitter', page_title: 'Twitter'});
                break;
            case 'Instagram':
                Firebase.analytics().logEvent('Social Media', { page_location:  'Dashboard/Instagram', page_title: 'Instagram'});
                break;
            case 'YouTube':
                Firebase.analytics().logEvent('Social Media', { page_location:  'Dashboard/YouTube', page_title: 'YouTube'});
                break;
            case 'LinkedIn':
                Firebase.analytics().logEvent('Social Media', { page_location:  'Dashboard/LinkedIn', page_title: 'LinkedIn'});
                break;
            default:
            // code block
        }

        openWebPage(socialMediaItem.url);
    }
    return (
        <Container>
            <Grid
                container
                justify={'space-around'}
            >
                {
                    socialMediaItems.map((socialMediaItem, index: number) =>
                        <SocialMediaListItem key={index} socialMediaItem={socialMediaItem} onClick={onClick} />
                    )
                }
            </Grid>
        </Container>
    );
};

export default SocialMediaPageController;